import React from 'react';
import './Copies.scss';
import mack from '../../assets/mack.jpg';
import { motion } from 'framer-motion';

function Copy7() {
  return (
    <section className="copies marginTopAdd">
      <p className="copies__copy">
        On the emotional side: Don’t wait to get your feelings out. “Talk about it! One way I have
        found that works to deactivate my own self-blame is just to own it,” Mack says. “This is a
        thing I have, sometimes it's bad, sometimes it's okay, but it doesn't define me as a
        person.”
      </p>
      <div className="inlinePhoto inlinePhoto--desktop--left">
        <img className="inlinePhoto__image" src={mack} alt="Portrait of Dr. Zakiya Rice" />
        {/* <p className="inlinePhoto__name inlinePhoto--description">Dr. Zakiya Rice</p> */}
        <p className="inlinePhoto__title inlinePhoto--description" style={{ paddingBottom: '5px' }}>
          Therapist Elizabeth Mack, LMFT
        </p>
      </div>
      <p className="copies__copy">
        A few years ago, Mack finally visited a dermatologist to seek help for her skin. “Upon
        revealing my rash, this lovely woman whom I had never met said ‘Oh my gosh, you poor thing.’
        I will never forget that. In a moment, she melted decades of internalized shame and
        embarrassment. It had never occurred to me that it wasn't somehow my fault, and that I was
        deserving of not just compassion, but effective treatment.”
      </p>
      <p className="copies__copy">
        Boey says that another big step toward acceptance and having people with eczema feel better
        about themselves is expanding the definition of “inclusion.”
      </p>
      <p className="copies__copy">
        “Everyone talks about being inclusive nowadays. I think being inclusive is not just about
        different races and different body shapes, it's also accepting people with medical
        conditions."
      </p>
      <motion.p
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 1, type: 'tween' }}
        className="pullQuote"
      >
        “Just because a person has a rash doesn't mean you can't put them in a [fashion] campaign.
        Just because a person has skin discoloration doesn't mean they can't be beautiful.”
      </motion.p>
    </section>
  );
}

export default Copy7;
